import React from 'react'

export default function DynamicPageOverview({data}) {
    if (!data) return null;
  return (
    <>
      <section className='final-overview-area'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-10'>
              <div className='final-overview-wrap'>
                <span>{data?.service_overview_title}</span>
                  <div dangerouslySetInnerHTML={{ __html: data?.service_overview_description }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
